import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils";

import type { I18nT } from "@lib/dashboardI18n";

// eslint-disable-next-line unused-imports/no-unused-vars
const uniqueId = (prefix: string) => {
  return `${prefix}${Math.ceil(Math.random() * 1000)}`;
};

const CampaignsList = lazy(() =>
  import("@campaigns/CampaignsList").then((module) => ({
    default: module.CampaignsList,
  }))
);

export const campaignsNRO: NavigationRoutingObject = {
  Component: CampaignsList,
  componentFeatureFlippers: ["campaigns_nro_component"],
  section: "messaging",
  heading: (t: I18nT<"dashboard-navigation">) => t("campaigns-sidebar-pill-menu-option", "Campaigns"),
  pageNameForTracking: () => "Campaigns",
  description: (t: I18nT<"dashboard-navigation">) =>
    t(
      "campaigns-sidebar-pill-menu-option-description",
      "Manage existing campaigns or create a new one. Recommended for single messages."
    ),
  icon: "new-nav-system-campaigns",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],

  additionalSearchableFeatures: (t: I18nT<"dashboard-navigation"> /**, { featureOn }*/) => ({
    campaigns: makeAdditionalSearchableFeature({
      heading: t("campaigns-sidebar-pill-menu-option", "Campaigns"),
      pathname: "/engagement/campaigns/:appGroupId",
      description: t(
        "campaigns-sidebar-pill-menu-option-description",
        "Manage existing campaigns or create a new one. Recommended for single messages."
      ),
      query: { campaignId: "campaigns" },
      additionalSearchTerms: [],
    }),
    /**
     * Disabling create pages for campaigns to reevaulate UX with optimistic campaign creation.
     * NOTE: Test have been disabled for this create results see GlobalSearch.test.ts when enabled.
     */
    // sms: makeAdditionalSearchableFeature({
    //   heading: featureOn("mms")
    //     ? t("campaigns-searchable-feature-sms-campaign-heading-sms-or-mms", "Create SMS/MMS Campaign")
    //     : t("campaigns-searchable-feature-sms-campaign-heading-sms-only", "Create SMS Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("sms_") },
    //   additionalSearchTerms: [],
    // }),
    // push: makeAdditionalSearchableFeature({
    //   heading: t("campaigns-searchable-feature-push-campaign-heading", "Create Push Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("push_") },
    //   additionalSearchTerms: [],
    // }),
    // email: makeAdditionalSearchableFeature({
    //   heading: t("campaigns-searchable-feature-email-campaign-heading", "Create Email Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("email_") },
    //   additionalSearchTerms: [],
    // }),
    // in_app_message: makeAdditionalSearchableFeature({
    //   heading: t("campaigns-searchable-feature-iam-campaign-heading", "Create In-App Messaging Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("in_app_message_") },
    //   additionalSearchTerms: [],
    // }),
    // webhook: makeAdditionalSearchableFeature({
    //   heading: t("campaigns-searchable-feature-webhook-campaign-heading", "Create Webhook Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("webhook_") },
    //   additionalSearchTerms: [],
    // }),
    // whats_app: makeAdditionalSearchableFeature({
    //   heading: t("campaigns-searchable-feature-whatsapp-campaign-heading", "Create WhatsApp Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("whats_app_") },
    //   additionalSearchTerms: [],
    // }),
    // content_card: makeAdditionalSearchableFeature({
    //   heading: t("campaigns-searchable-feature-content-card-campaign-heading", "Create Content Card Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("content_card_") },
    //   additionalSearchTerms: [],
    // }),
    // api: makeAdditionalSearchableFeature({
    //   heading: t("campaigns-searchable-feature-api-campaign-heading", "Create API Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("api_") },
    //   additionalSearchTerms: [],
    // }),
    // transactional: makeAdditionalSearchableFeature({
    //   heading: t(
    //     "campaigns-searchable-feature-transactional-email-campaign-heading",
    //     "Create Transactional Email Campaign"
    //   ),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("transactional_") },
    //   additionalSearchTerms: [],
    // }),
    // multi: makeAdditionalSearchableFeature({
    //   heading: t("campaigns-searchable-feature-multichannel-campaign-heading", "Create Multichannel Campaign"),
    //   pathname: "/engagement/campaigns/:campaignId/:appGroupId",
    //   query: { campaignId: () => uniqueId("multi_") },
    //   additionalSearchTerms: [],
    // }),
  }),
  defaultRoute: "/engagement/campaigns/:appGroupId",
};
